import {inject, observer} from "mobx-react";
import React              from "react";
import {toJS}         from "mobx";


//core components
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid      from "../../components/Grid/ItemGrid";
import IconCardNew   from "../../components/Cards/IconCardNew.jsx";
import Button        from "../../components/CustomButtons/Button.jsx";
import EditableTable from "../../components/Table/EditableTable";



import * as FileSaver from 'file-saver';
import * as XLSX      from 'xlsx';

import SweetAlert from "react-bootstrap-sweetalert";
import { v4 as uuidv4 } from 'uuid';


import CircularProgress from "material-ui/Progress/CircularProgress";
import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import Divider   from "material-ui/Divider/Divider";

// material-ui icons
import AssignmentIcon from '@material-ui/icons/Assignment';

import {
    EXCEL_TEMPLATE_METADATA_FIELDS,
    EXCEL_TEMPLATE_FILENAME,
    PHOTOSELFIE_BASE_URL
} from '../../utils/constants';

import withStyles from "material-ui/styles/withStyles";
import configurationStyle from "../../assets/jss/material-dashboard-pro-react/layouts/configurationStyle";
import '../../assets/css/configuration.css';


import Cookies from "universal-cookie";

const cookies = new Cookies();

@inject('store')
@observer
class Configuration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            text: '',
            uploadDisabled:false,
            modificaDisabled:true,
            uploadedOK: false,
            showIcon: false,
            fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            fileExtension: '.xlsx',
            tokenURL:null,
            projectID: '',
            projectName: '',
            projectType: '',
            merchantEmail: '',
            language: '',
            landingPageUrl:'',
            sendExcelToRef: '',
            landingPageState: '',
            landingPageEnabled: '',
            urlGenerated: true,
            send_data_referent: 0,
            showAlert: false,
            showInviaDatiReferentAlert: false,
            showChangeLangAlert: false,
            showUploadDataMultiTeam: false,
            errorUploadExcel: false,
            show_table_with_url_for_teams: false,
            tbl_with_team_and_link_data: [],

        }
        this.store = this.props.store.appState;
    }

    componentWillMount(){
        this.getProjectConfigurationData();
    }

    componentDidMount() {

    }

    getProjectConfigurationData = () => {
        let self = this;
        self.store.get_project_configuration_data({idProject: self.state.projectID}, (res) => {
            self.setState({
                projectID: res[0].id,
                projectName: res[0].project_name,
                projectType: res[0].project_type,
                merchantEmail: res[0].merchant_email,
                language: res[0].lang,
                landingPageUrl: res[0].url,
                // send_data_referent: parseInt(res[0].send_excel_to_ref, 10) == 1 ? true : false,
                send_data_referent: parseInt(res[0].send_excel_to_ref, 10),
                landingPageState: res[0].state,
                landingPageEnabled: res[0].landing_page_enabled,
            });
            // console.log(self.state.send_data_referent);
            parseInt(res[0].state, 10) === 0 ? localStorage.setItem('session_closed', 'true') : localStorage.setItem('session_closed', 'false');
        });
    };

    generaLandingPageURL = () => {
        const self = this;
        const project_unique_token = uuidv4().substr(0, 8);
        const project_langingpage_url = PHOTOSELFIE_BASE_URL + '/upload-photo/' + project_unique_token;

        let projectData = {};
        projectData.idProject = self.state.projectID;
        projectData.project_name = self.state.projectName;
        projectData.project_type = self.state.projectType;
        projectData.merchant_email = self.state.merchantEmail;
        projectData.lang = self.state.language;
        projectData.url = project_langingpage_url;
        // projectData.sendExcelToRef = self.state.send_data_referent ? 1 : 0;
        projectData.sendExcelToRef = self.state.send_data_referent;
        projectData.state = self.state.landingPageState;
        projectData.landingPageEnabled = self.state.landingPageEnabled;

        self.store.saveProjectData(projectData, function (result) {
            if (result === true) {
                self.setState({
                    showAlert: true,
                    project_unique_token: project_unique_token,
                    landingPageUrl: project_langingpage_url,
                    urlGenerated: true
                })

            } else {
                // console.log('URL not generated')
            }
        });
    };


    generateUrlsForAllTeams = () => {
        const self = this;
        // const project_unique_token = uuidv4().substr(0, 8);
        const project_id = self.state.projectID;
        self.store.getProjectTeams({project_id: project_id}, function (response) {
            // console.log("ALL Project Teams ", teams);
            if (response.length > 0) {
                // console.log("ALL Project Teams ", response);
                let data = [];
                let i = 1;
                response.forEach((t) => {
                    const team = t.team.replace(/\s/g, "_").toLowerCase();
                    data.push({
                        id: i,
                        team: t.team.toLowerCase(),
                        link: self.state.landingPageUrl + '/' + team
                    });
                    i++;
                });
                self.setState({show_table_with_url_for_teams: true, tbl_with_team_and_link_data: data});
            } else {
                // console.log('Nessuna squadra trovata per il progetto ', project_id);
            }
        })
    }

    handleCheckboxChange = (checked) => {

        const self = this;
        let projectData = {};

        projectData.idProject = self.state.projectID;
        projectData.project_name = self.state.projectName;
        projectData.project_type = self.state.projectType;
        projectData.merchant_email = self.state.merchantEmail;
        projectData.lang = self.state.language;
        projectData.url = self.state.landingPageUrl;
        // projectData.sendExcelToRef = self.state.send_data_referent ? 1 : 0;
        projectData.sendExcelToRef = checked === true ? 1 : 0;
        projectData.state = self.state.landingPageState;
        projectData.landingPageEnabled = self.state.landingPageEnabled;

        self.store.saveProjectData(projectData,function (result) {
            // console.log("update-result", result);
            if (result===true){
                // this.setState({send_data_referent: !this.state.send_data_referent});

                self.setState({
                    showInviaDatiReferentAlert: true,
                    send_data_referent: checked === true ? 1 : 0,
                })

            } else {
                // console.log('URL not generated')
            }
        });
    }

    setLanguage = (event) => {

        const self = this;
        self.store.handle_app_lang(event.target.value);
        const lang = event.target.value;

        // const DEFAULT_TEXT = import(`../../assets/translations/${lang}`).then((lang) => {
        import(`../../assets/translations/${lang}`).then((lang) => {
            self.setState({
                text: lang
            })
        }).catch((error) => {
            // console.log('import translation: error ', error);
            // console.error(`"${self.state.language}" not yet supported`);
        });

        let projectData = {};
        projectData.idProject = self.state.projectID;
        projectData.project_name = self.state.projectName;
        projectData.project_type = self.state.projectType;
        projectData.merchant_email = self.state.merchantEmail;
        projectData.lang = event.target.value;
        projectData.url = self.state.landingPageUrl;
        // projectData.sendExcelToRef = self.state.send_data_referent ? 1 : 0;
        projectData.sendExcelToRef = self.state.send_data_referent;
        projectData.state = self.state.landingPageState;
        projectData.landingPageEnabled = self.state.landingPageEnabled;


        self.store.saveProjectData(projectData,function (result) {
            // console.log("update-result", result);
            if (result===true){
                // this.setState({send_data_referent: !this.state.send_data_referent});
                self.setState({
                    showChangeLangAlert: true,
                    language: event.target.value
                });
            } else {
                // console.log('error during update language');
            }
        });
    };

    modifyData = () => {
        this.store.showEditableTable = true;
        this.store.uploadDisabled = true;
        this.store.modificaDisabled = true;
    };

    readExcel = (file) => {

        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);
            fileReader.onload = (e) => {
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, {type: "buffer"});
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                let data = XLSX.utils.sheet_to_json(ws);
                // console.log("BEFORE: ", data);
                data.forEach((item) => {
                    if(item.PhotoID === ""){
                        // console.log("ID FOTO EMPTY");
                        delete item['PhotoID'];
                    }
                });
                // console.log("DATA AFTER", data);
                data = data.filter((item) => item.PhotoID === undefined);
                // console.log("AFTER: ", data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((data) => {

            const self = this;
            let unique_teams = [...new Set(data.map(item => item.Squadra))];
            // console.log("UNIQUE-TEAMS: ", unique_teams);

            //===== check project type ======
            let project_type = cookies.get('project_type');
            //console.log(project_type);
            //=== JUST FOR TEST REMOVE IT
            // project_type = 'C';

            if(project_type === 'S'){
                // console.log("Progetto Singolo");
                // console.log(unique_teams.length);
                if(unique_teams.length > 1){
                    self.setState({showUploadDataMultiTeam: true});
                    return;
                }
            }

            // console.log('EXCEL_DATA_BEFORE', data);

            const pType = self.store.project_type;
            const project_id = self.store.project_id;

            // console.log("PROJECT_DATA: ", pType + '-' + project_id);

            data.forEach(item => {
                // const team = item.Squadra.trim().toLowerCase();
                item['project_type'] = pType;
                item['project_id'] = project_id;
            });

            // console.log('EXCEL_DATA_AFTER', data);

            self.setState({ loading:true });

            self.store.uploadExcelData(data, function(res){
                // console.log(res);
                if(res){
                    // console.log("upload-data-response", res);

                    self.store.dataUploadedLength = data.length;
                    self.setState({uploadedOK: true, loading: false});
                    self.store.uploadDisabled = true;
                    self.store.modificaDisabled = false;
                    cookies.set('upload_closed',true);
                }else{
                    self.setState({
                        showEmptyDataError:true,
                        errorUploadExcel:true,
                        loading:false
                    })
                    // console.log('error');
                }
            });

            // self.store.dataUploadedLength = data.length;
            // self.setState({uploadedOK: true});
            // self.store.uploadDisabled = true;
            // self.store.modificaDisabled = false;
        });
    };

    downloadExcelTemplate = () => {

        const first_column = EXCEL_TEMPLATE_METADATA_FIELDS[0];
        const second_column = EXCEL_TEMPLATE_METADATA_FIELDS[1];
        const third_column = EXCEL_TEMPLATE_METADATA_FIELDS[2];
        const fourth_column = EXCEL_TEMPLATE_METADATA_FIELDS[3];
        const fifth_column = EXCEL_TEMPLATE_METADATA_FIELDS[4];

        let exportData = [];
        let obj = {};

        obj[first_column] = '';
        obj[second_column] = '';
        obj[third_column] = '';
        obj[fourth_column] = '';
        obj[fifth_column] = '';

        exportData.push(obj);

        const ws = XLSX.utils.json_to_sheet(exportData);
        // console.log(ws);
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: this.state.fileType});
        FileSaver.saveAs(data, EXCEL_TEMPLATE_FILENAME + this.state.fileExtension);


    };

    exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'teams_links': ws }, SheetNames: ['teams_links'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], {type: this.state.fileType});
        FileSaver.saveAs(data, fileName + this.state.fileExtension);
    }

    hideAlert = () => {
        if(this.state.showUploadDataMultiTeam){
            this.setState({showUploadDataMultiTeam: false});
            window.location.reload();
        }
        if(this.state.errorUploadExcel){
            this.setState({errorUploadExcel: false});
        }
        this.setState({showAlert: false, showInviaDatiReferentAlert: false, showChangeLangAlert: false, uploadedOK:false});
    };

    hideAlertWithUrlForTeams = () => {
        this.setState({show_table_with_url_for_teams: false});
    };

    handleToggle = () => {
        this.setState({
            newsletter_checked: !this.state.send_data_referent,
        });
    }

    render() {
        // const session_closed = localStorage.getItem('session_closed');
        const landing_page_status = cookies.get('landing_page_status');
        const upload_closed = cookies.get('upload_closed');

        let session_closed = parseInt(landing_page_status, 10) === 0 ? true : false;

        const {classes} = this.props;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT)
        const {
            loading,language,
            urlGenerated,
            landingPageUrl,
            send_data_referent,
            validLanguage,
            showAlert,
            showInviaDatiReferentAlert,
            showChangeLangAlert,
            showUploadDataMultiTeam,
            uploadedOK,
            errorUploadExcel,
            projectID,
            projectName,
            show_table_with_url_for_teams,
            tbl_with_team_and_link_data,
            projectType
        } = this.state;
        const checked = parseInt(send_data_referent, 10) === 1 ? true : false;

        return (
            <div>
                <GridContainer>
                    <ItemGrid xs={12} sm={12} md={12}><h2 style={{textAlign: "center"}}>{projectID} - {projectName}</h2></ItemGrid>
                    <ItemGrid xs={12} sm={12} md={6}>
                        <IconCardNew
                            icon={AssignmentIcon}
                            iconColor="rose"
                            title={DEFAULT_TEXT.upload_metadata_title.toUpperCase()}
                            content={
                                <div>
                                    {
                                        !loading
                                            ?
                                            <div>
                                                <div className={classes.config}>
                                                    <input type="file"
                                                           id='file'
                                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
                                                           disabled={session_closed || upload_closed || this.store.uploadDisabled}
                                                           onChange={(e) => {
                                                               const file = e.target.files[0];
                                                               this.readExcel(file);
                                                           }}
                                                    />
                                                    <label htmlFor="file">{DEFAULT_TEXT.btn_upload.toUpperCase()}</label>
                                                    <Button style={{width: '150px'}}
                                                            disabled={!upload_closed===true || session_closed || this.store.showEditableTable}
                                                            round
                                                            color={ session_closed || !upload_closed===true || this.store.showEditableTable ? 'primary' : 'rose'}
                                                            onClick={this.modifyData}>
                                                        {DEFAULT_TEXT.btn_edit.toUpperCase()}
                                                    </Button>

                                                    <div style={{width: '30%', paddingTop: '50px'}}
                                                         onClick={this.downloadExcelTemplate}>
                                                        <p className={classes.downloadExcelLabel}>{[DEFAULT_TEXT.download_label]}</p>
                                                        <Divider/>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div style={loading ? {
                                                display: "flex",
                                                justifyContent: "center"
                                            } : null}>
                                                <CircularProgress className={classes.progress}/>
                                            </div>
                                    }
                                </div>
                            }
                        />
                    </ItemGrid>


                    <ItemGrid xs={12} sm={12} md={6}>
                        <IconCardNew
                            icon={AssignmentIcon}
                            iconColor="rose"
                            title={DEFAULT_TEXT.upload_metadata_title.toUpperCase()}
                            content={
                                <div>
                                    {
                                        // !loading
                                        //     ?
                                            <div>
                                                <div className={classes.firstRowContainer}>
                                                    <div>
                                                        <Button style={{width: '12rem',height:'2.5rem'}}
                                                                disabled={session_closed || !language || landingPageUrl.length > 0}
                                                                round
                                                                color={language && !landingPageUrl ? 'purple' : 'primary'}
                                                                onClick={this.generaLandingPageURL}>
                                                            {DEFAULT_TEXT.genera_url}
                                                        </Button>
                                                    </div>
                                                    <div>
                                                        {
                                                            urlGenerated
                                                                ?
                                                                <div style={{
                                                                    marginBottom: '-10px',
                                                                    marginLeft: '20px',
                                                                    width: '100%',
                                                                    fontFamily:'Roboto',
                                                                    fontSize:'12px'
                                                                }}>
                                                                    <span
                                                                        className={classes.spanConfig}> {landingPageUrl ? landingPageUrl : null} </span>
                                                                    <Divider style={{width:'15rem'}}/>
                                                                </div>
                                                                : null
                                                        }
                                                    </div>
                                                </div>

                                                        <div className={classes.secondRowContainer}>
                                                            <div id='svg'>
                                                                <Button style={{width: '12rem',height:'2.5rem'}} round disabled={session_closed} color={session_closed ? 'primary' : "purple"} size="sm">
                                                                    <Select
                                                                        displayEmpty
                                                                        renderValue={
                                                                            language ? null
                                                                                : () => <p className={'select-para'} style={{marginLeft:'0',fontSize:'0.7rem'}}>{ DEFAULT_TEXT.Select_lang}</p>
                                                                        }
                                                                        fullWidth={true}
                                                                        style={{color: "white"}}
                                                                        disableUnderline={true}
                                                                        value={language}
                                                                        error={validLanguage === false}
                                                                        onChange={this.setLanguage}
                                                                        inputProps={{
                                                                            name: "simpleSelect",
                                                                            id: "simple-select"
                                                                        }}>
                                                                        <MenuItem value = "it"><span className={'span-lang'}>Italiano </span></MenuItem>
                                                                        <MenuItem value = "en"><span className={'span-lang'}> English </span></MenuItem>
                                                                        <MenuItem value = "fr"><span className={'span-lang'}> Français</span></MenuItem>
                                                                        <MenuItem value = "de"><span className={'span-lang'}> Deutsch</span></MenuItem>
                                                                        <MenuItem value = "es"><span className={'span-lang'}> Español</span></MenuItem>
                                                                    </Select>
                                                                </Button>
                                                            </div>

                                                            <div style={{paddingLeft: '20px'}}>
                                                                <Button style={{width: '12rem',height:'2.5rem'}}
                                                                        disabled={projectType === 'S' ? true : false}
                                                                        round
                                                                        color={'purple'}
                                                                        onClick={() => this.generateUrlsForAllTeams()}>
                                                                    {DEFAULT_TEXT.genera_url_x_cat_btn_lbl.toUpperCase()}
                                                                </Button>
                                                            </div>
                                                        </div>

                                                <div className={classes.thirdRowContainer}>
                                                    <div>
                                                        <input
                                                            // value={send_data_referent}
                                                            disabled={session_closed}
                                                            type="checkbox"
                                                            checked={checked}
                                                            onChange={(event) => this.handleCheckboxChange(event.target.checked)}/>
                                                    </div>

                                                    <div style={{paddingTop: '6px', paddingLeft: '5px'}}>
                                                        <p>{[DEFAULT_TEXT.abilita_invio_dati_ref]}</p>
                                                    </div>

                                                </div>

                                            </div>

                                            // :
                                            // <div style={this.state.loading ? {
                                            //     display: "flex",
                                            //     justifyContent: "center"
                                            // } : null}>
                                            //     <CircularProgress className={classes.progress}/>
                                            // </div>
                                    }
                                </div>
                            }
                        />

                        {
                            showAlert || showInviaDatiReferentAlert || showChangeLangAlert || uploadedOK ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                confirmBtnText='Ok'
                                                success
                                                confirmBtnStyle={{background: 'green'}}
                                                style={{fontSize: '8px'}}
                                                title={
                                                    showInviaDatiReferentAlert ? DEFAULT_TEXT.config_update_send_data_to_ref_alert_msg : showChangeLangAlert ? DEFAULT_TEXT.config_update_lang_alert_msg : uploadedOK ? DEFAULT_TEXT.upload_confirm_msg : DEFAULT_TEXT.gen_url_confirm_msg
                                                }
                                                onConfirm={this.hideAlert}
                                                confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }

                        {
                            showUploadDataMultiTeam || errorUploadExcel ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                confirmBtnText='Ok'
                                                warning
                                                confirmBtnStyle={{background: 'green'}}
                                                style={{fontSize: '8px'}}
                                                title={
                                                    showUploadDataMultiTeam ? DEFAULT_TEXT.config_upload_data_project_type_comune_msg : errorUploadExcel ? "Errore durante excel upload" : ''
                                                }
                                                onConfirm={this.hideAlert}
                                                confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }

                        {
                            show_table_with_url_for_teams ?
                                <div style={{fontSize: '8px', width: '600px', overflow: 'scroll'}}>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                confirmBtnText='Export to EXCEL'
                                                cancelBtnText={'Chiudi'}
                                                success
                                                showCancel={true}
                                                confirmBtnStyle={{background: 'green'}}
                                                style={{fontSize: '8px', width: '600px'}}
                                                title={projectID + " - " + projectName}
                                                onConfirm={() => this.exportToCSV(tbl_with_team_and_link_data, 'LINK_TEAMS_' + projectID)}
                                                onCancel={this.hideAlertWithUrlForTeams}
                                                confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}
                                                cancelBtnCssClass={
                                                    this.props.classes.button + " " + this.props.classes.danger
                                                }
                                            >
                                                <table align="center" className="inst-container">
                                                    <tbody>
                                                    {/*<div >*/}
                                                        <tr className={"ernest"}>
                                                            <th>SQUADRA</th>
                                                            <th>LINK</th>
                                                        </tr>
                                                        {tbl_with_team_and_link_data && tbl_with_team_and_link_data.map((row, key) => (
                                                            <tr key={row.id} className={"ernest"}>
                                                                <td> {row.team}</td>
                                                                <td style={{marginLeft: '30px'}}>
                                                                    <a href={row.link} target={"_blank"} style={{color: '#0000ff'}}>{row.link}</a>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    {/*</div>*/}
                                                    </tbody>
                                                </table>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }

                        {/*{*/}
                        {/*    uploadedOK ?*/}
                        {/*        <div>*/}
                        {/*            <GridContainer justify={"center"}>*/}
                        {/*                <ItemGrid xs={12} sm={6}>*/}
                        {/*                    <SweetAlert*/}
                        {/*                        confirmBtnText='Ok'*/}
                        {/*                        success*/}
                        {/*                        confirmBtnStyle={{background: 'green'}}*/}
                        {/*                        title={DEFAULT_TEXT.upload_confirm_msg}*/}
                        {/*                        onConfirm={this.hideAlert}*/}
                        {/*                        confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>*/}
                        {/*                    </SweetAlert>*/}
                        {/*                </ItemGrid>*/}
                        {/*            </GridContainer>*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        null*/}
                        {/*}*/}
                    </ItemGrid>
                    {
                        this.store.showEditableTable && !session_closed
                            ?
                                <EditableTable/>
                            :   null
                    }
                </GridContainer>
            </div>
        )
    }
}

export default withStyles(configurationStyle)(Configuration);



// WEBPACK FOOTER //
// ./src/views/Settings/Configuration.jsx